import { GameAction } from "./game.action";

export const GAME_MESSAGE_CONTEXT = {
	getAll: GameAction.fetchAll.type,
	getDetail: GameAction.getDetail.type,
	getByCollectionId: GameAction.fetchByCollectionId.type,
};

export const EXPERIMENT_FLAGS = {
	HIDDEN_LIVE: "hidden-live",
};

export const FETCH_ONLY_NEEDED_GAMES_FLAG_KEY = "fetch_only_needed_games";
